import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';
import { isMobileBrowser } from '../../../base/environment/utils';
const useStyles = makeStyles(() => {
    return {
        flex: {
            display: 'flex',
            flex: 1
        },
        base: {
            height: '100%',
            overflow: 'auto'
        }
    };
});
/**
 * Component that disables {@code touchmove} propagation below it.
 *
 * @returns {ReactElement}
 */
function TouchmoveHack({ children, isModal, flex }) {
    if (!isModal || !isMobileBrowser()) {
        return children;
    }
    const touchMoveElementRef = useRef(null);
    /**
     * Atlaskit's {@code Modal} uses a third party library to disable touchmove events
     * which makes scrolling inside dialogs impossible. We therefore employ this hack
     * to intercept and stop the propagation of touchmove events from this wrapper that
     * is placed around the chat conversation from the {@code ChatDialog}.
     *
     * @param {Event} event - The touchmove event fired within the component.
     * @returns {void}
     */
    function handleTouchMove(event) {
        event.stopImmediatePropagation();
    }
    useEffect(() => {
        if (touchMoveElementRef === null || touchMoveElementRef === void 0 ? void 0 : touchMoveElementRef.current) {
            touchMoveElementRef.current.addEventListener('touchmove', handleTouchMove, true);
        }
        return () => {
            if (touchMoveElementRef === null || touchMoveElementRef === void 0 ? void 0 : touchMoveElementRef.current) {
                touchMoveElementRef.current.removeEventListener('touchmove', handleTouchMove, true);
            }
        };
    }, []);
    const classes = useStyles();
    return (React.createElement("div", { className: clsx(classes.base, flex && classes.flex), ref: touchMoveElementRef }, children));
}
export default TouchmoveHack;
